import React from 'react';
import { Clickable } from '@moda/om';
import { hrefFor } from '../../../routers';
import { ResponsiveImage } from '../../ResponsiveImage';
import { OrderItem } from '../../../hooks/useOrder';

import './OrderItemImage.scss';

interface Props {
  item: OrderItem;
  imageSize: 'small' | 'medium';
}

export const OrderItemImage: React.FC<Props> = ({
  item: {
    attributes: {
      details: { name },
      images: { small, medium },
      productHref,
      variantId
    }
  },
  imageSize
}) => {
  const [, designerSlug, productSlug] = productHref.split('/');

  const href = hrefFor.ProductDetailPage({
    vertical: 'women',
    designerSlug,
    productSlug,
    variantId: String(variantId)
  });

  const imageSrc = imageSize === 'small' ? small : medium;

  return (
    <Clickable to={href}>
      <ResponsiveImage
        className="OrderItemImage__image"
        src={imageSrc}
        alt={name}
        maxWidth={160}
        maxHeight={280}
      />
    </Clickable>
  );
};
